import { computed, reactive } from "vue";
import { arrayToString } from "../helpers";
import { useAPIStore } from "@/stores/APIStore";
import { storeToRefs } from "pinia";
import { extractFieldValue } from "../forms";
import { getPermissionBundlesFromRole } from "../permissions";

export default class GP {
    /**
     * Formats a rule argument, name has been shortened due to heavy use
     * @param arg the arg to be formatted may be a list or string
     * @param fn a format function to apply to the arg
     * @param bold whether or not a function needs to be marked as bold
     * @returns the formated string for a rule
     */
    static rarg(arg, fn = null, alt = null, bold = true, altbold = false) {
        const applyGPBold = (val) => {
            if (!bold) return val
            return arrayToString(
                val.split("{%GP_JOIN%}")
                    .map(val => !['and', ','].includes(val) ? `{%GP_BOLD%}${val}{%END_GP_BOLD%}` : val)
                , "and")
        }

        if (Array.isArray(arg) && bold) arg = arg.join("{%GP_JOIN%}")
        else if (Array.isArray(arg)) arg = arrayToString(arg, "and")

        if (arg && fn) return fn(applyGPBold(arg))
        else if (arg) return applyGPBold(arg)
        else if (alt !== null && alt !== undefined) {
            if (altbold) return applyGPBold(alt)
            return alt
        }
        return '';
    }

    static applyFormat(rules, headerForm, subForm, options) {
        const extractRoleAndAction = () => {
            let roles = extractFieldValue(subForm)
            if (Array.isArray(roles)) {
                roles = roles.map(x => x.displayValue || x)
            }
            const action = extractFieldValue(headerForm)
            return [roles, action]
        }

        const extractValues = () => {
            const args = {}

            options.forEach(option => {
                const optionName = extractFieldValue(option.mainForm)
                const optionKeyObject = rules.options.find(option => option.displayName == optionName)
                if (!optionKeyObject) return
                const optionKey = optionKeyObject.name
                const optionValuesObject = extractFieldValue(option.subForm)
                if (!optionValuesObject) return
                const optionValues = optionValuesObject.map(x => x.displayValue)
                args[optionKey] = optionValues
            })

            return args
        }

        const formatter = rules.format(...extractRoleAndAction())
        return formatter(extractValues())
    }

    static breakBold(str) {
        let firstBold = false
        return str.split("{%GP_BOLD%}").map((str, indx) => [indx != 0, str]).map(([bold, str], indx) => str.split("{%END_GP_BOLD%}").map((str2, indx2) => [indx != 0 && indx2 == 0, str2])).reduce((acc, v) => [...acc, ...v], []).map(([bold, str]) => {
            if (bold && !firstBold) {
                firstBold = true
                return [bold, true, str]
            }
            return [bold, false, str]
        })
    }

    static use(rules) {
        const standardOptions = [
            {
                name: "Role",
                displayName: "Role",
                async fn() {
                    const APIStore = useAPIStore()
                    const roles = await APIStore.getRoles()
                    if(!rules.userPermissions) return roles
                    const allowedRoles = roles.filter(
                        role => rules.userPermissions.some(
                            perms => perms.every(
                                perm => getPermissionBundlesFromRole(role)
                                    .map(pb => pb.name)
                                    .includes(perm)
                            )
                        )
                    )
                    return allowedRoles
                },
                fnDisplayValue: "name"
            }
        ]

        const combinedOptions = [...standardOptions, ...(rules.options || [])]

        return reactive({
            enabled: computed(() => {
                const APIStore = useAPIStore()
                const { granularPermissionsConfig } = storeToRefs(APIStore)
                return granularPermissionsConfig?.value?.[rules.enabledKey] || false
            }),
            conditions: [],
            ...rules,
            options: combinedOptions
        })
    }
}